import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textalignleft",
  "use": "icon-textalignleft-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textalignleft\"><path d=\"M28.444444 1024v-113.777778h967.111112v113.777778H28.444444zM28.444444 0h967.111112v113.777778H28.444444V0z m512 568.888889H28.444444V455.111111h512v113.777778z\" fill=\"#000000\" p-id=\"3012\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol